let env_config = {};

const loadEnvVariables = () => {

    //const basePath = "http://localhost:8080/";
    const basePath = './';
    const envFilePath = `${basePath}env.json`;
    const request = new XMLHttpRequest();
    request.open("GET", envFilePath, false); // false makes it synchronous
    request.send(null);
    if (request.status === 200) {
        try {
            env_config = JSON.parse(request.responseText);
        } catch (error) {
            console.error("Error parsing environment variables:", error);
        }
    } else {
        console.error("Failed to load environment variables.");
    }
};
// Load environment variables once during app startup
loadEnvVariables();
export const getEnvVariable = (envVariable) => {
    return env_config[envVariable] || "";
};